import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthStateService {
  // Initialize auth state from sessionStorage to persist across page refreshes
  private readonly authStateSubject = new BehaviorSubject<boolean>(false);
  public authState$ = this.authStateSubject.asObservable();

  constructor() {
    // Restore auth state from sessionStorage on service initialization
    this.restoreAuthState();
  }

  /**
   * Get initial auth state from sessionStorage
   */
  private getInitialAuthState(): boolean {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return false;
    }
    const token = sessionStorage.getItem('auth_token');
    return !!(token && token !== 'undefined' && token.trim() !== '');
  }

  /**
   * Restore auth state from sessionStorage
   */
  private restoreAuthState(): void {
    const isLoggedIn = this.getInitialAuthState();
    this.authStateSubject.next(isLoggedIn);
  }

  updateAuthState(isLoggedIn: boolean) {
    this.authStateSubject.next(isLoggedIn);
  }
}